import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, FormikHelpers, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { object, string, date } from 'yup';

import { UserAvatar } from '@components/Feature/User/user-avatar';
import { FormGroupControl } from '@components/Base';

import { memberIdRegister, MemberIdRegisterPayload } from '../action';
import { selectAuthRouteReducer } from '../selector';

const GROUP_PROPS = { className: 'mb-3' };

type FormValues = MemberIdRegisterPayload;

const FormForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { error } = useSelector(selectAuthRouteReducer);
  const { isSubmitting } = useFormikContext<FormValues>();

  return (
    <Form>
      {error && <Alert className="mt-3" variant="danger">{error}</Alert>}

      <FormGroupControl
        name="memberId"
        label={t('common:memberId')}
        groupProps={GROUP_PROPS}
        required
      />

      <FormGroupControl
        type="date"
        name="dob"
        label={t('user.dob')}
        groupProps={GROUP_PROPS}
        required
      />

      <div className="d-grid gap-2">
        <Button type="submit" disabled={isSubmitting} variant="primary">
          {t('common:signIn')}
        </Button>
        <Button variant="outline-secondary" onClick={() => navigate('-1')}>
          {t('common:cancel')}
        </Button>
      </div>
    </Form>
  );
}

const AuthMemberIdPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initialValues: FormValues = {
    memberId: '',
    dob: '',
  };

  const validationSchema = object({
    memberId: string().required(t('validation:required')),
    dob: date().required(t('validation:required')),
  });

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: MemberIdRegisterPayload = values;
    dispatch(memberIdRegister(payload));
    setSubmitting(false);
  };

  return (
    <Card>
      <Card.Header className="text-center">
        <UserAvatar />
      </Card.Header>
      <Card.Body>
        <Card.Title>{t('registration.title')}</Card.Title>
        <Card.Text>{t('registration.title')}</Card.Text>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <FormForm />
        </Formik>
      </Card.Body>
    </Card>
  );
};

export { AuthMemberIdPage };
